<template>
  <section>
    <m-art-edit
        :form.sync="form"
        :form-rules="rules"
        :resetFormCallback="resetFormCallback"
        :submit-success-func="submitSuccessFunc"
        :submit-func="submitFunc"
        label-width="130px"
    >
      <template v-slot:form-items>
        <m-card title="基本信息" v-loading="loading">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="标签组名称" prop="labelGroupName">
                <el-input v-model.trim="form.labelGroupName"></el-input>
              </el-form-item>
              <el-form-item label="添加标签" prop="labelName">
                <el-tag
                    v-for="(tag,index) in form.labelName"
                    :key="index"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(index)">
                  {{ tag }}
                </el-tag>
                <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput"
                           icon="el-icon-plus"></el-button>
              </el-form-item>
              <el-form-item label="选择模式">
                <el-radio-group v-model="form.pattern">
                  <el-radio label="RADIO">单选</el-radio>
                  <el-radio label="MULTIPLE_CHOICE">多选</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否启用">
                <el-switch
                    v-model="form.status"
                    active-value="Enable"
                    inactive-value="Disable"
                ></el-switch>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="form.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </m-card>
      </template>
    </m-art-edit>
  </section>
</template>

<script>
import api from "plus/api";
import upload from "components/upload";
import detailsMixin from "@/mixin/detailsMixin";
import dialogEnum from "@/utils/dialogEnum";

export default {
  name: "privilege.tags.details",
  components: {upload},
  mixins: [detailsMixin],
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      details: {},
      form: {
        labelGroupName: "",
        labelName: [],
        pattern: 'RADIO',
        remark: '',
        status: 'Enable',
      },
      rules: {
        labelGroupName: [{required: true, message: "请填写标签组名称"}],
        labelName: [{required: true, type: 'array', message: "请填写标签"}],
      },
    };
  },
  computed: {
    submitFunc() {
      return this.isEdit ? api.manage.updateTags : api.manage.addTags;
    },
  },
  created() {
    if (this.isEdit) {
      api.manage
          .getTags({id: this.$route.query.id})
          .then((res) => {
            this.form = res.data.data;
          })
          .finally(() => {
            this.loading = false;
          });
    }
  },
  methods: {
    submitSuccessFunc() {
      this.$message.success("提交成功");
    },
    handleClose(index) {
      this.form.labelName.splice(index, 1)
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue && !this.form.labelName.includes(inputValue)) {
        this.form.labelName.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    resetFormCallback() {
      this.form = {
        labelGroupName: "",
        labelName: [],
        pattern: '',
        remark: '',
        status: '',
      };
    },
  },
};
</script>
<style lang="less" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
